import { NotificationConstants } from "../constants";
import { NotificationService } from "../services";

const getNotification = () => {
  const request = (notification) => {
    return {
      type: NotificationConstants.GETNOTIFICATION_REQUEST,
      notification,
    };
  };
  const success = (notification) => {
    return {
      type: NotificationConstants.GETNOTIFICATION_SUCCESS,
      notification,
    };
  };
  const failure = (error) => {
    return { type: NotificationConstants.GETNOTIFICATION_FAILURE, error };
  };

  return (dispatch) => {
    dispatch(request());

    NotificationService.getNotification().then((notification, error) => {
      if (notification) {
        dispatch(success(notification));
      } else {
        dispatch(failure(error.toString()));
      }
    });
  };
};

const getUnreadNotification = () => {
  const request = (unreadnotification) => {
    return {
      type: NotificationConstants.GETUNREAD_NOTIFICATION_REQUEST,
      unreadnotification,
    };
  };
  const success = (unreadnotification) => {
    return {
      type: NotificationConstants.GETUNREAD_NOTIFICATION_SUCCESS,
      unreadnotification,
    };
  };
  const failure = (error) => {
    return {
      type: NotificationConstants.GETUNREAD_NOTIFICATION_FAILURE,
      error,
    };
  };

  return (dispatch) => {
    dispatch(request());

    NotificationService.getUnreadNotification().then(
      (unreadnotification, error) => {
        if (unreadnotification) {
          dispatch(success(unreadnotification));
        } else {
          dispatch(failure(error.toString()));
        }
      }
    );
  };
};

const readNotification = () => {
  const request = (readnotification) => {
    return {
      type: NotificationConstants.READ_NOTIFICATION_REQUEST,
      readnotification,
    };
  };
  const success = (readnotification) => {
    return {
      type: NotificationConstants.READ_NOTIFICATION_SUCCESS,
      readnotification,
    };
  };
  const failure = (error) => {
    return {
      type: NotificationConstants.READ_NOTIFICATION_FAILURE,
      error,
    };
  };

  return (dispatch) => {
    dispatch(request());

    NotificationService.readNotification().then(
      (readnotification, error) => {
        if (readnotification) {
          dispatch(success(readnotification));
        } else {
          dispatch(failure(error.toString()));
        }
      }
    );
  };
};

const getNotificationStatus = (id) => {
  const request = (notificationStatus) => {
    return {
      type: NotificationConstants.GETNOTIFICATION_STATUS_REQUEST,
      notificationStatus,
    };
  };
  const success = (notificationStatus) => {
    return {
      type: NotificationConstants.GETNOTIFICATION_STATUS_SUCCESS,
      notificationStatus,
    };
  };
  const failure = (error) => {
    return {
      type: NotificationConstants.GETNOTIFICATION_STATUS_FAILURE,
      error,
    };
  };

  return (dispatch) => {
    dispatch(request());

    NotificationService.getNotificationStatus(id).then(
      (notificationStatus, error) => {
        if (notificationStatus) {
          dispatch(success(notificationStatus));
        } else {
          dispatch(failure(error.toString()));
        }
      }
    );
  };
};

export const NotificationActions = {
  getNotification,
  getUnreadNotification,
  readNotification,
  getNotificationStatus,
};
